import { useCanManageEmployees } from 'utils/useCanManageEmployees';
import { Button, SvgIcon } from '@mui/material';
import PlusCircleIcon from 'mdi-react/PlusCircleIcon';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import employeeDrawer from 'store/app/ui/drawers/employee/action';
import { I18n } from 'utils/i18n';

const AddEmployeeButton = () => {
  const canManageEmployees = useCanManageEmployees();
  const dispatch = useDispatch();
  const openDrawer = useCallback(() => {
    dispatch(employeeDrawer.open());
  }, [dispatch]);

  if (!canManageEmployees) {
    return null;
  }

  return (
    <Button onClick={openDrawer} variant="contained" color="primary">
      <SvgIcon sx={{ fontSize: 18, mr: '5px' }}>
        <PlusCircleIcon />
      </SvgIcon>
      {I18n.t('PeoplesScene.Add employee')}
    </Button>
  );
};

export default AddEmployeeButton;
